/**
 * Tracks which tournaments the user has already seen the welcome modal for.
 *
 * Persisted as a JSON array of tournament ids under a single localStorage key.
 * "Seen once per tournament" semantics: a brand-new tournament id is unseen
 * (so the modal shows again), but a known id is suppressed across reloads.
 */
const STORAGE_KEY = "tournament-welcome-seen-v1"
/** Cap the stored list so it cannot grow unbounded over many tournaments. */
const MAX_REMEMBERED = 50

function readSeenIds(): string[] {
  if (typeof window === "undefined") return []
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed)
      ? parsed.filter((id): id is string => typeof id === "string")
      : []
  } catch {
    return []
  }
}

export function isTournamentWelcomeSeen(tournamentId: string): boolean {
  if (!tournamentId) return false
  return readSeenIds().includes(tournamentId)
}

export function markTournamentWelcomeSeen(tournamentId: string): void {
  if (typeof window === "undefined" || !tournamentId) return
  const ids = readSeenIds()
  if (ids.includes(tournamentId)) return
  // Keep most-recent ids, drop the oldest beyond the cap.
  const next = [...ids, tournamentId].slice(-MAX_REMEMBERED)
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // Storage unavailable (private mode / quota) — non-fatal; modal may reshow.
  }
}
